"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMessage = void 0;
var getErrorMessage = exports.getErrorMessage = function getErrorMessage(error) {
  if (error instanceof Response) {
    return error.json().then(function (_ref) {
      var message = _ref.message;
      return message;
    });
  }
  return error.message;
};